<template>
  <div class="ept-drawer" :class="drawerClasses">
    <div class="ept-drawer__content">
      <div v-if="!navbarDisable" class="flex justify-between items-center">
        <button type="button" class="header__link header__link--primary" @click.prevent="close" aria-label="Fechar">
          <i class="icon far fa-times text-2xl" aria-hidden="true"></i>
        </button>
        <a class="relative overflow-hidden w-24 h-full" href="/">
          <img src="~images/logo_ept.png" class="w-full" alt="Logo" />
        </a>
        <field-search />
      </div>
      <slot />
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import FieldSearch from '../header/FieldSearch'

export default {
  components: {
    FieldSearch
  },

  props: {
    direction: {
      type: String,
      default: 'top'
    },

    value: {
      type: Boolean,
      default: false
    },

    navbarDisable: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showing: false
  }),

  computed: {
    drawerClasses() {
      const classes = [`ept-drawer-${this.direction}`]

      if (this.showing) {
        classes.push(`${this.direction}-open`)
      }

      return classes.join(' ')
    }
  },

  watch: {
    value(newValue) {
      this.showing = newValue
    }
  },

  methods: {
    open() {
      this.showing = true

      this.$nextTick(() => {
        this.$emit('open')
        this.$emit('input', true)
      })
    },

    close() {
      this.showing = false

      this.$nextTick(() => {
        this.$emit('close')
        this.$emit('input', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ept-drawer {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  background-color: white;
  transition: all 0.5s ease;
  z-index: 10;

  &__container {
    position: relative;
    @apply mt-4;
    @apply flex;
    @apply flex-col;
  }

  &__content {
    flex: 1;
    position: relative;
    padding: 1rem 1.875rem;
    overflow-y: auto;
  }
}

.ept-drawer-left {
  left: -120%;
  &.left-open {
    left: 0;
  }
}

.ept-drawer-right {
  right: -120%;
  &.right-open {
    right: 0;
  }
}

.ept-drawer-top {
  top: -120%;
  left: 0;
  &.top-open {
    top: 0;
  }
}

.ept-drawer-bottom {
  top: 100%;
  &.bottom-open {
    top: 0;
  }
}
</style>
